<loading *ngIf="loading">
  <ng-container i18n="@@front.forgotPassword.loading">Sending a reset password email</ng-container>
</loading>

<success *ngIf="success">
  <p i18n="@@front.forgotPassword.success.message">A reset email has been sent to your inbox</p>
  <a routerLink="/home" class="btn btn-primary" i18n="@@front.forgotPassword.success.actionButton">Home Page</a>
</success>

<div *ngIf="!loading && !success" class="form forget-password">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div *ngIf="error" class="alert alert-warning">
      {{error}}
    </div>

    <form-field class="front" label="Email" i18n-label="@@front.forgotPassword.email.label">
      <div class="d-flex align-items-center">
        <input type="email" formControlName="email" placeholder="Your email address" class="flex-grow" i18n-placeholder="@@front.forgotPassword.email.placeholder">
        <img src="assets/images/icons/email.svg" alt="" class="icon">
      </div>
    </form-field>
    <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100">
      <ng-container *ngIf="loading" i18n="@@front.forgotPassword.submitLoading">Loading ...</ng-container>
      <ng-container *ngIf="!loading" i18n="@@front.forgotPassword.submitButton">Send email</ng-container>
    </button>
  </form>
</div>